import React from 'react';
import './custom.css'
const Membership = () => {
    return (
        <div style={{ background: '#F2F8FF' }}>
            <section className='mx-3 mx-md-5' style={{ padding: '150px 0', }}>
                <div className='text-center'>
                    <h1 data-aos="flip-down" className='member_header'>Membership</h1>
                    <span className='down_span'>Be a O2Club member and start earning Tokens</span>
                </div>
                <div className='member_para d-none d-md-block'>
                    <p data-aos="fade-up" data-aos-duration="2000">Personalised invites coming soon. Contact us below to learn more on arrival date in your city.
                        Members mining blocks daily. Day ends at 3.30 pm Kyoto time.</p>
                </div>
                <div className='mt-2 fs-6 text-center d-block d-md-none' style={{ fontFamily: "Poppins", fontWeight: '400', fontSize: '20px', color: '#111111' }}>
                    <p className='minig_text' data-aos="fade-up" data-aos-duration="2000">Personalised invites coming soon. Contact us below to learn more on arrival date in your city.Members mining blocks daily. Day ends at 3.30 pm Kyoto time.</p>
                </div>
                <div className='d-flex justify-content-center  '>
                    <img className='bg-primary py-2 px-3 rounded' src='/img/banknotes coins and a credit card lying in a brown wallet.png' width="172px" alt="" />
                </div>
                <div className='text-center mt-3'>
                    <strike className='strike_mem'>Price $899 lifetime or $5 weekly</strike><br /><br />
                    <span className=' text-center freeBtn'><img className='me-1' src="/img/vector.svg" alt="" /> FREE for 2022 by invite only</span>
                </div>
            </section>
        </div>
    );
};

export default Membership;